import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/src/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#007ACC',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#EA5455',
        info: '#2196F3',
        success: '#28C76F',
        warning: '#FF9F43'
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
});
